import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Collapse, message } from 'antd';
import { TableRowsSkeleton } from '../../components/skeleton/skeleton';
import SquareIntegration, {
  SquareIntegrationHeader,
} from './square/SquareIntegration';
import GoogleBusinessIntegration, {
  GoogleBusinessIntegrationHeader,
} from './google/GoogleBusinessIntegration';
import GoogleAdsIntegration, {
  GoogleAdsIntegrationHeader,
} from './google-ads/GoogleAdsIntegration';
import { PageHeader } from '../../components/ui';
import './integrations.css';

const Integrations = () => {
  const globalCompany = useSelector((state) => state.companyReducer.selected);
  const [loading] = useState({ integrations: false });
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const connected = searchParams.get('googleConnected');
    if (connected === '1') {
      message.success('Google Business Profile connected successfully!');
    } else if (connected === '0') {
      message.error(
        'Failed to connect Google Business Profile: ' +
          (searchParams.get('error') || 'unknown error')
      );
    }
    if (connected !== null) {
      searchParams.delete('googleConnected');
      searchParams.delete('error');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const collapseItems = [
    {
      key: 'square',
      label: <SquareIntegrationHeader globalCompany={globalCompany} />,
      children: <SquareIntegration globalCompany={globalCompany} />,
      className: 'integration-panel square-integration-panel',
      showArrow: true,
    },
    {
      key: 'google',
      label: <GoogleBusinessIntegrationHeader globalCompany={globalCompany} />,
      children: <GoogleBusinessIntegration globalCompany={globalCompany} />,
      className: 'integration-panel google-integration-panel',
      showArrow: true,
    },
    {
      key: 'google-ads',
      label: <GoogleAdsIntegrationHeader globalCompany={globalCompany} />,
      children: <GoogleAdsIntegration globalCompany={globalCompany} />,
      className: 'integration-panel google-ads-integration-panel',
      showArrow: true,
    },
  ];

  return (
    <div>
      <div className="bg-white p-4 dark:bg-slate-800 sm:p-6 lg:p-8">
        {loading.integrations ? (
          <div className="w-full py-4">
            <TableRowsSkeleton count={4} rowHeight="h-16" />
          </div>
        ) : (
          <div className="mx-auto max-w-5xl space-y-8">
            <PageHeader
              title="Integrations"
              description="Connect your Point of Sale systems and other tools."
            />
            <div className="shadow">
              <Collapse
                accordion={false}
                defaultActiveKey={['square']}
                items={collapseItems}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Integrations;
